// All comments in English.
import type { RiskLevel } from "@/types/common";

export default function RiskLevelBadge({ level }: { level: RiskLevel }) {
  const cls =
    level === "High"
      ? "bg-red-100 text-red-700"
      : level === "Medium"
      ? "bg-amber-100 text-amber-700"
      : "bg-emerald-100 text-emerald-700";
  return <span className={`rounded px-2 py-0.5 text-xs font-medium ${cls}`}>{level}</span>;
}
